import { render, staticRenderFns } from "./company-advanced-card.vue?vue&type=template&id=68bb7808&scoped=true&"
import script from "./company-advanced-card.vue?vue&type=script&lang=js&"
export * from "./company-advanced-card.vue?vue&type=script&lang=js&"
import style0 from "./company-advanced-card.vue?vue&type=style&index=0&id=68bb7808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb7808",
  null
  
)

export default component.exports